<template>
  <el-select ref="select" :value="value" multiple class="cargo-multiple-select" v-bind="$attrs" v-on="$listeners" @visible-change="onVisibleChange">
    <slot />
  </el-select>
</template>

<script>
export default {
  name: 'CargoMultipleSelect',
  props: {
    value: { type: Array, required: true },
    placeholder: { type: String, default: '' }
  },
  data() {
    return {
      isEdit: false // 是否正在编辑
    }
  },
  watch: {
    value() {
      this.$nextTick(() => {
        this.onVisibleChange(this.isEdit)
      })
    }
  },
  created() {
    this.$nextTick(() => {
      this.onVisibleChange(this.isEdit)
    })
  },
  methods: {
    onVisibleChange(isEdit) {
      this.isEdit = isEdit
      this.$nextTick(() => {
        const select = this.$refs.select
        const tags = select.$el.querySelector('.el-select__tags')
        if (!tags || !tags.childNodes || tags.childNodes.length === 0 || !select.selected) {
          return
        }
        const text = select.selected.map(item => {
          return item.$el.innerText
        }).join(',')
        let customDisplay = null
        let input = null
        for (const child of tags.childNodes) {
          if (!child.classList) {
            continue
          }
          if (child.classList.contains('custom-display')) {
            customDisplay = child
          } else if (child.classList.contains('el-select__input')) {
            input = child
          }
        }
        if (!customDisplay) {
          customDisplay = document.createElement('span')
          customDisplay.className = 'custom-display'
          tags.insertBefore(customDisplay, tags.childNodes[0])
        }
        if (this.isEdit) {
          customDisplay.style.display = 'none'
          if (input) {
            input.style.display = ''
            input.value = ''
            input.setAttribute('placeholder', this.getMultiDisplay(text, input.offsetWidth) || this.placeholder)
            input.focus()
          }
        } else {
          customDisplay.style.display = ''
          customDisplay.innerText = this.getMultiDisplay(text, customDisplay.offsetWidth)
          customDisplay.setAttribute('title', this.getMultiDisplay(text))
          if (input) {
            input.style.display = 'none'
          }
        }
      })
    },
    getMultiDisplay(text, width) {
      if (typeof width === 'number') {
        return this.getTextEllipsis(text, width, 12, 9)
      }
      return text
    },
    getTextEllipsis(text, width, fontSize = 12, paddingWidth = 25) {
      if (width > 0) {
        const textWidth = this.getTextWidth(text, fontSize, paddingWidth)
        if (textWidth > width) {
          for (let i = 3; i <= text.length; ++i) {
            const subText = text.substring(0, i)
            const subTextWidth = this.getTextWidth(subText, fontSize, paddingWidth)
            if (subTextWidth > width) {
              return text.substring(0, i - 2) + '...'
            }
          }
        }
      }
      return text
    },
    getTextWidth(text, fontSize, paddingWidth) {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      ctx.font = `normal ${fontSize}px sans-serif`
      return ctx.measureText(text).width + paddingWidth
    }
  }
}
</script>

<style lang="scss" scoped>
.cargo-multiple-select::v-deep.el-select {
  .el-select__tags {
    .custom-display {
      width: 100%;
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      margin-left: 9px;
    }

    .el-tag--info {
      display: none;
    }

    .el-select__input {
      margin-left: 9px;
      font-size: 12px;
    }
  }
}
</style>
